<template>
    <router-view></router-view>
</template>

<script>
export default {
    name: 'shop'
}
</script>

<style></style>
